<template>
  <BarChart :options="chartOptions"></BarChart>
</template>

<script>
import BarChart from '@wizer/core/components/chart/BarChart'
import ChartMixin from '@/mixins/ChartMixin'

export default {
  name: 'BarChartWrapper',
  mixins: [ChartMixin],
  components: {
    BarChart,
  },
  created() {
    this.$store.dispatch('setIsFillMissingDates', true)
  },
}
</script>
